module.exports = __webpack_public_path__ + "static/media/gal-14.486c8880.jpeg";